/**
 * @param e KeyboardEvent
 */
export const isBackspaceKeyCode = (e) => {
  return e.keyCode === 8
}

/**
 * @param e KeyboardEvent
 */
export const isDeleteKeyCode = (e) => {
  return e.keyCode === 46
}

/**
 * @param e KeyboardEvent
 */
export const isNumberKeyCode = (e) => {
  return isNumericKey(e) || isCommaKey(e) || isPeriodKey(e)
}

/**
 * @param e KeyboardEvent
 */
export const isNumericKey = (e) => {
  return (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)
}

/**
 * @param e KeyboardEvent
 */
export const isCommaKey = (e) => {
  return e.keyCode === 188
}

/**
 *  is Period
 * @param e KeyboardEvent
 */
export const isPeriodKey = (e) => {
  return e.keyCode === 190
}


